import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IUpperLimitField {
	changeUpperLimit: (value: string) => void;
}

const UpperLimitField: React.FC<IUpperLimitField> = ({ changeUpperLimit }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterUpperLimit') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeUpperLimit(onlyDigits);
			return onlyDigits;
		},
		[changeUpperLimit],
	);

	return (
		<FormInput
			testId="UpperLimitField"
			name="upperLimit"
			label="upperLimitLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(UpperLimitField);
